import MessagingLabel from 'LuxKit/Label/MessagingLabel'
import { rem } from 'polished'
import type { CSSProperties } from 'react'
import styled from 'styled-components'

const Tags = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${rem(4)};
`

const Tag = styled(MessagingLabel)`
  && {
    background-color: var(--background-color);
    color: var(--text-color);
    border-color: transparent;
  }
`

interface TagStyle extends CSSProperties {
  '--background-color': string
  '--text-color': string
}

interface Props {
  urgencyTags: Array<App.ExperienceUrgencyTag>
}

function ExperienceConfiguredUrgencyTags({ urgencyTags }: Props) {
  if (!urgencyTags.length) return null

  return <Tags data-testid="experience-configured-urgency-tags">
    {urgencyTags.map(tag => <span
      key={tag.id}
      style={{
        '--background-color': tag.bgColor,
        '--text-color': tag.textColor,
      } as TagStyle}
      data-testid="experience-configured-urgency-tag"
    >
      <Tag variant="urgency">{tag.text}</Tag>
    </span>)}
  </Tags>
}

export default ExperienceConfiguredUrgencyTags
